import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { VehicleAttributeCategoryModel } from './vehicleattributecategory.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class VehicleAttributeCategoryService {
  constructor(private authService: AuthService, private http: Http) { }


  public GetVehicleAttributeCategoryList(input?: DataListModel): Observable<IAPIResponse> {
    let geteVehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      geteVehicleAttributeUrl = geteVehicleAttributeUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(geteVehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleAttributeCategoryList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let geteVehicleAttributeUrl = WeGoConfig.API_EXPORT_VEHICLEATTRIBUTECATEGORY_LIST + "?" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(geteVehicleAttributeUrl, options);
  }

  public GetVehicleAttributeCategoryByHashId(vehicleAttributeCategoryHashId: string): Observable<IAPIResponse> {
    let getvehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTE_CATEGORY_BY_HASH + "?vehicleAttributeCategoryHashID=" + vehicleAttributeCategoryHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getvehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddNewVehicleAttributeCategory(vehicleAttributeCategoryModel: VehicleAttributeCategoryModel): Observable<IAPIResponse> {
    let body = vehicleAttributeCategoryModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_VEHICLEATTRIBUTE_CATEGORY_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetVehicleAttributeCategoryByInstance(instanceHashId: string): Observable<IAPIResponse> {
    let getvehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTECATEGORY_BY_INSTANCE + "?instanceHashId=" + instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getvehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute-category/models/vehicleattributecategory.service.ts